const doc = [({"da":({"js":({"agenda_item_elements":({"edit":({"audio":({"choose_audio_file":"Vælg lydfil"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;